/**
 * Created by BFR on 28/06/2018.
 */
define('mailsController',[
  'module',
  'logger',
  'underscore',
  'backbone',
  'app',
  'jquery',
  'mailsView',
  'gmailUtils',
  'emptyView',
  'entities/mails'
], function(
  module,
  Logger,
  _,
  Backbone,
  App,
  $,
  MailsView,
  GmailUtils,
  EmptyView
) {
  'use strict';

  var MailsController = {

    showTab: function(data) {
        if (data.model.contactSecId) {
            this.getMailsForContact(data);
        } else {
            this.getMails(data);
        }
    },

    getMails: function(data) {
        App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(new EmptyView());

        if (this.gmailUtils) {
            this.gmailUtils.off('gmail_utils:loaded');
            this.gmailUtils.off('gmail_utils:signInNeeded');
        }

        if (!this.gmailUtils) {
            this.gmailUtils = GmailUtils.getInstance();
        }
        
        this.gmailUtils.on('gmail_utils:loaded', _.bind(function() {
            var mail = data.model.get('email');
            this.gmailUtils.listMessages(mail?mail:data.model.get('code'), _.bind(function(msgs) {
                msgs = _.sortBy(msgs, 'internalDate');

                this.view = new MailsView({
                    collection: new Backbone.Collection(msgs),
                    customer: data.model
                });
                App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.view);
            }, this));
        }, this));

        this.gmailUtils.on('gmail_utils:signInNeeded', _.bind(function() {
            this.view = new MailsView({
                collection: null,
                customer: null
            });
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.view);
        }, this));

        this.gmailUtils.connect();

    },

    getMailsForContact: function() {
        //debugger;
      /*var emailRequest = App.request('mails:find-by-endusercontact', data.model.get('secId'));

      $.when(emailRequest.fetch()).done(_.bind(function() {
          this.view = new MailsView({
              collection: emailRequest,
              customer: data.model
          });

          App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.view);
      }, this));*/
    }
  };

  module.exports = MailsController;
});
